export default __webpack_public_path__ + "static/media/zombie-logo2.cf054994.png";